import { FC } from 'react';
import { Icon, SpriteGlyph } from '../../../shared/ui/Icon';
import { cn } from '@distribute/frontend/utils';

type Props = {
  label: string;
  icon: SpriteGlyph;
  onClick?: () => void;
  isActive: boolean;
  className?: string;
};

export const WorkspaceNavigationItem: FC<Props> = ({
  label,
  icon,
  onClick,
  isActive,
  className,
}) => {
  return (
    <button
      className={cn(
        'px-3 py-2 rounded-md flex flex-row gap-x-3 cursor-pointer group focus:outline-none text-sm font-medium',
        className,
        {
          'bg-gray-200 text-gray-800': isActive,
          'text-gray-700 hover:text-gray-800 hover:bg-base-black/[0.04]':
            !isActive,
        }
      )}
      onClick={onClick}
    >
      <Icon
        glyph={icon}
        width={20}
        className={cn({
          'text-gray-500 group-hover:text-gray-600': !isActive,
          'text-gray-600': isActive,
        })}
      />
      <span>{label}</span>
    </button>
  );
};
